/**
 * HELP ARTICLE SLUGS THAT WERE RENAMED, each to the slug its article lives at
 * now (th-drkx5m).
 *
 * A slug is an address three places keep: a `/help/articles/<slug>` URL
 * somebody saved or shared, a workspace `?articleId=<slug>`, and the
 * `help_articles` stamp on an Artemis reply already written. Renaming an
 * article's file moves all three, so the old slug is entered here and keeps
 * resolving:
 *
 *   - `router/helpRoutes.js` redirects the public article route to the current
 *     slug, so the address bar states it;
 *   - `stores/documentation.js` answers a retired slug in `articles` with the
 *     current article, so every keyed lookup (the workspace Help tab, a
 *     message's article foot, an inline article link) resolves with no site of
 *     its own.
 *
 * A leaf with no imports: the router mounts it, and it must not pull the
 * corpus into the entry chunk.
 *
 * Only a RENAME belongs here. An article that was removed has no current slug,
 * and its link renders the "no longer has" state `HelpArticle.vue` owns.
 */
export const RETIRED_HELP_SLUGS = Object.freeze({
  "see-the-hunts-a-listing-could-fill":
    "see-the-hunts-an-availability-could-fill",
});

/**
 * The slug an article lives at now.
 *
 * @param {string} slug - A help article slug, current or retired.
 * @returns {string} The current slug: the rename's target for a retired one,
 *   and `slug` itself for any other.
 */
export function currentHelpSlug(slug) {
  return Object.hasOwn(RETIRED_HELP_SLUGS, slug)
    ? RETIRED_HELP_SLUGS[slug]
    : slug;
}
